import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-fac-history-chat',
  templateUrl: './fac-history.component.html',
  styleUrls: ['./fac-history.component.scss']
})
export class FacHistoryChatComponent implements OnChanges {
  @Input() facHistory;
  @Input() activitiesOnly = false;
  historyList = [];
  historyListFilter = [];
  historyFilterOpen = false;
  combosList = [
    {
      id: 1,
      value: 'Todos',
      type: 'all'
    },
    {
      id: 2,
      value: 'Contatos',
      type: 'contacts'
    },
    {
      id: 3,
      value: 'Dados cadastrais',
      type: 'registration_data'
    },
    {
      id: 4,
      value: 'Atividades',
      type: 'activities'
    },
    {
      id: 5,
      value: 'Outros',
      type: 'others'
    }
  ];

  private iconExt = {
  doc: 'word',
  docx: 'word',
  pdf: 'pdf',
  ppt: 'powerpoint',
  pptx: 'powerpoint',
  xls: 'excel',
  xlsx: 'excel'
  };

  historyFilter = {value: 'Filtros', type: 'all'};

  ngOnChanges(changes: SimpleChanges) {
    if (changes.facHistory && !changes.facHistory.firstChange) {
        this.historyList = this.facHistory;
        this.historyFilterMatch();
    }
    if (this.activitiesOnly) {
      this.historyFilter = {value: 'Atividades', type: 'activities'};
      this.historyFilterMatch();
    }
  }

  setFilter(item) {
    this.historyFilter = item;
    this.historyFilterOpen = false;
    this.historyFilterMatch();
  }

  historyFilterMatch() {
    this.historyListFilter = [];
    if (this.historyList && this.historyList.length > 0) {
      this.historyListFilter = this.historyList.filter(history => {
        if ((history.type === 'discard' || history.type === 'transfer') && this.historyFilter.type === 'others') {
          return true;
        }
        if (history.type === this.historyFilter.type ||  this.historyFilter.type === 'all') {
          return true;
        }
        return false;
          });
    }
  }

  downloadFile(item) {
    const a = document.createElement('a');
    a.href = item.url;
    a.target = '_blank';
    a.download = item.name;
    // start download
    a.click();
  }

  setFilePreview(item) {
    let icon = null;
    icon = this.isNotImage(item) || null;
    if (!icon) {
      return item.url;
    } else {
      return `../../../../assets/svgs/${icon}.svg`;
    }
  }

  isNotImage(item) {
    return this.iconExt[item.name.split('.').pop()];
  }
}
